<template>
	<div :class="{container: !collapse}"><slot></slot></div>
</template>

<script>

	export default {
		name: 'container',
		props: {
			collapse: {
				type: Boolean,
				default: false
			}
		}
	}

</script>

<style lang="scss" scoped>

  @import "container.scss";

  .container {
    @include container;
  }
</style>



// WEBPACK FOOTER //
// src/components/_global/container.vue